<template>
  <main id="main-container">
    <Hero title="Configuracion de Dispositivo" page="device-config" />
    <div class="content">
      <h2>Configuraciones del Dispositivo</h2>
        <Card title="Actualizar Variables del Dispositivo">
            <div class="row">
                <form class="form-class" @submit="sendData">
                    
                        <div class="col-md-6 col-12" >
                            <label for="" class="form-label">Tiempo de Guardado (Min)</label>
                            <input
                                class="form-control"
                                type="number"
                                placeholder="Tiempo de Guardado (Min)"
                                min="10"
                                v-model="data.svt"
                                required
                            />
                        </div>

                        <div class="col-md-6 col-12" >
                            <label for="" class="form-label">Intervalo de envio de Datos (Seg)</label>
                            <input
                            class="form-control"
                            type="number"
                            placeholder="Intervalo de envio de Datos (Seg)"
                            min="10"
                            required
                            v-model="data.mti"
                            />
                        </div>

                        <div class="col-12">
                            <button type="submit" class="btn btn-info mb-3 pull-right">
                            Actualizar
                            </button>
                        </div>
                </form>
            </div>
        </Card>
    </div>
  </main>
</template>
<script>
import useIndex from '@/composables/useIndex'
import emitter from '@/eventBus';
import {useStore} from 'vuex'
import { ref, onMounted } from 'vue'
import useApp from "@/composables/useApp"

export default {
        components: {  },
        name: 'device-config',
        setup() {
            const store = useStore()
            const topic = `${store.state.selectedDevice.userId}/${store.state.selectedDevice.dId}/_params/actdata`
            const {
                index_datos,          
            } = useIndex()

            const {ToastMsg, ToastMsgInfo, ToastMsgWarning} = useApp()

            const data = ref({mti:null, svt:null})

            onMounted(()=>{
                data.value.mti =  index_datos.value.mti / 1000
                data.value.svt = index_datos.value.svt
            })
            

            const sendData =  (event) => {
                event.preventDefault();
                if (data.svt == 0 || data.mti == 0){
                    ToastMsgWarning("Solo Numeros Distintos a Cero !", "cloud", 3000 )
                    return 
                }
                const toSend = {
                topic,
                msg: {
                    svt:  Math.abs(data.value.svt),
                    mti : Math.abs(data.value.mti) * 1000
                    },
                };
                emitter.emit("mqtt-sender", toSend);    
                index_datos.value.svt = toSend.msg.svt
                index_datos.value.mti = toSend.msg.mti
                ToastMsgInfo("Actualizacion de Parametros Completada !", "cloud", 3000)
            }
            
        return{
            data,
            sendData
        }
    }
}
</script>